import { defineStore, storeToRefs } from 'pinia'

import ChatMessage from '~/models/chat/ChatMessage'
import { useUrlBuilder } from '~/stores/url-builder'

export const useChatBuilder = defineStore('chat-builder', {
  state: () => {
    return {}
  },
  actions: {
    async actionGetChatMessages(chatId, lastChatMessageId = null) {
      const config = useRuntimeConfig()
      const baseUrl = config.public.baseUrl
      const urlBuilderStore = useUrlBuilder()
      const { getRequestHeaders } = storeToRefs(urlBuilderStore)

      const queryParams = new URLSearchParams({
        ...(lastChatMessageId ? { lastChatMessageId } : {}),
      })

      const getChatsUrl = `${baseUrl}/chats/${chatId}/messages?${queryParams}`

      try {
        const response = await $fetch(getChatsUrl, {
          headers: getRequestHeaders.value,
        })

        if (!response) return null
        if (!response.result) return null

        const chats = response.result.chatMessages.map((chat) => {
          const chatMessage = new ChatMessage()
          chatMessage.formData(chat)
          return chatMessage
        })
        return chats
      } catch (error) {
        console.error(error)
      }
    },
    async actionPostChatMessage(chatId, message) {
      const config = useRuntimeConfig()
      const baseUrl = config.public.baseUrl
      const urlBuilderStore = useUrlBuilder()
      const { getRequestHeaders } = storeToRefs(urlBuilderStore)

      const body = {
        message,
      }

      const url = `${baseUrl}/chats/${chatId}/messages`

      let response = null
      try {
        response = await $fetch(url, {
          method: 'POST',
          headers: { ...getRequestHeaders.value },
          body,
        })

        return response.result
      } catch (error) {
        return {
          error: true,
          message: error.data.messages[0],
        }
      }
    },
    async actionGetChatConfig(chatId) {
      const config = useRuntimeConfig()
      const baseUrl = config.public.baseUrl
      const urlBuilderStore = useUrlBuilder()
      const { getRequestHeaders } = storeToRefs(urlBuilderStore)

      const url = `${baseUrl}/chats/${chatId}`

      try {
        const response = await $fetch(url, {
          method: 'GET',
          headers: { ...getRequestHeaders.value },
        })

        return response.result
      } catch (error) {
        console.error(error)
      }
    },
    async actionGetMentionUsers(chatId, { page = 0, search = '' }) {
      const config = useRuntimeConfig()
      const baseUrl = config.public.baseUrl
      const urlBuilderStore = useUrlBuilder()
      const { getRequestHeaders } = storeToRefs(urlBuilderStore)

      const queryParams = new URLSearchParams({
        Page: page,
      })

      if (search) {
        queryParams.append('Search', search)
      }
      const url = `${baseUrl}/chats/${chatId}/users?${queryParams}`
      try {
        const response = await $fetch(url, {
          method: 'GET',
          headers: { ...getRequestHeaders.value },
        })

        return response.result
      } catch (error) {
        console.error(error)
      }
    },
    async actionGetChatParticipants(chatId, page = 0) {
      const config = useRuntimeConfig()
      const baseUrl = config.public.baseUrl
      const urlBuilderStore = useUrlBuilder()
      const { getRequestHeaders } = storeToRefs(urlBuilderStore)

      const url = `${baseUrl}/chats/${chatId}/participants?Page=${page}`

      try {
        const response = await $fetch(url, {
          method: 'GET',
          headers: { ...getRequestHeaders.value },
        })

        return response.result
      } catch (error) {
        console.error(error)
      }
    },
  },

  getters: {},
})
